import { Grid2 } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

function Checkable({ attributes = {}, label = 'Label' }) {
    return (
        <Grid2 container spacing={2} alignItems="center">
            <FormControlLabel control={<Checkbox {...attributes} />} label={label} />
        </Grid2>
    );
}

export default Checkable;
